import { GET_RULE, GET_RULE_SUCCESS, GET_RULE_FAILED } from "./actionsTypes";

const initialState = {
  rules: {},
  loadingSettings: false,
  error: {
    message: "",
  },
};

const RulesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RULE:
      state = { ...state, loadingSettings: true };
      break;
    case GET_RULE_SUCCESS:
      state = { ...state, rules: action.payload, loadingSettings: false };
      break;
    case GET_RULE_FAILED:
      state = {
        ...state,
        error: {
          message: "Error",
        },
        loadingSettings: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RulesReducer;
